import * as React from "react";
import {ReactNode} from "react";

import FeedbackForError from "./FeedbackForError";
interface IProps {
    children: ReactNode;
}

interface IState {
    hasError: boolean;
}

export class ErrorBoundary extends React.Component <IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            hasError: false,
        }
    }

    public componentDidCatch() {
        this.setState({hasError: true});
    }

    public render(): ReactNode {
        if (this.state.hasError) {
            return <FeedbackForError handleClick={this.handleClick} />;
        }

        return this.props.children;
    }

    private handleClick = (): void => {
        window.location.reload();
    };

}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/presentation/error_boundary.tsx